import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import { FieldArray, reduxForm } from 'redux-form';
import { Link } from 'react-router';
import SortableWrap from './sortable/container';

import LangSwitch from '../../../../shared/lang/switch';
import Filters from '../../../../shared/filters/main';

import DeleteLandingModal from './delete-modal/main';

const Main = props => {
	const submit = !props.landingsFormData.shouldTranslate ?
		props.landingsFormSubmit :
		props.landingsFormSubmitTranslation;

	return (
		<div className="offers-form-wrap offers-form-wrap__landings">
			<div className="offers-form-wrap__langs">
				<LangSwitch langs={props.landingsTabLangs} onChangeLang={props.landingsFormChangeLanguage}/>
			</div>
			<div className="offers-form-wrap__landings-filters">
				<div className="offers-form-wrap__landings-filters-container">
					<Filters {...props} filters={props.landingsFilters} {...props.landingsFilters} />
				</div>
				<button className="ui-btn ui-btn-primary" onClick={() => props.fetchLandingsData(props.data.id)}>
					{props.intl('Apply')}
				</button>
			</div>
			<form className="ui-form offers-form__landing" onSubmit={props.handleSubmit(submit)}>
				<FieldArray
					intl={props.intl}
					can={props.can}
					name="landing"
					component={RenderFieldArray}
					title={props.intl('Add landing')}
					remove={props.showDeleteModal}
					affiliatesLookup={props.affiliatesLookup}
					shouldTranslate={props.landingsFormData.shouldTranslate}
					langs={props.landingsFormData.languagesOptions}
					offerPromoLabelsOptions={props.landingsFormData.offerPromoLabelsOptions}
					defaultLang={props.landingsFormData.defaultLanguage}
					locationsLookups={props.locationsLookupsLandings}
				/>

				<FieldArray
					intl={props.intl}
					can={props.can}
					name="transit"
					component={RenderFieldArray}
					title={props.intl('Add transit page')}
					remove={props.showDeleteModal}
					affiliatesLookup={props.affiliatesLookup}
					shouldTranslate={props.landingsFormData.shouldTranslate}
					langs={props.landingsFormData.languagesOptions}
					offerPromoLabelsOptions={props.landingsFormData.offerPromoLabelsOptions}
					defaultLang={props.landingsFormData.defaultLanguage}
					locationsLookups={props.locationsLookupsLandings}
				/>

				<div className="ui-form__element buttons-wrap">
					{ props.can('edit') && (
						<button className="ui-btn ui-btn-primary">{ props.intl('Save') }</button>
					)}
					<Link to='programs/' className="ui-btn ui-btn-cancel">{ props.intl('Cancel') }</Link>
				</div>
			</form>
			{props.deleteLandingModal.show && props.deleteLandingModal.data.type
				? <DeleteLandingModal
					intl={props.intl}
					data={props.landingsFormData.initialValues[`${props.deleteLandingModal.data.type}`]}
					id={props.deleteLandingModal.data.id}
					remove={props.landingsDelete}
					close={props.showDeleteModal}
				/>
				: null}
		</div>
	);
};

const RenderFieldArray = (props) => (
	<SortableWrap {...props}
		useDragHandle={true}
		lockToContainerEdges={true}
		lockAxis={'y'}
		onSortEnd={sortProps => {
			const { oldIndex, newIndex } = sortProps;
			props.fields.move(oldIndex, newIndex);
		}}/>
);

Main.propTypes = {
	locationsLookupsLandings: PropTypes.func,
	handleSubmit: PropTypes.func,
	landingsFormSubmit: PropTypes.func,
	landingsTabLangs: PropTypes.array,
	landingsDelete: PropTypes.func,
	landingsFormChangeLanguage: PropTypes.func,
	landingsFormSubmitTranslation: PropTypes.func,
	intl: PropTypes.func,
	can: PropTypes.func,
	affiliatesLookup: PropTypes.func,
	landingsFormData: PropTypes.object
};

RenderFieldArray.propTypes = {
	locationsLookupsLandings: PropTypes.func,
	fields: PropTypes.object,
	title: PropTypes.string,
	langs: PropTypes.array,
	defaultLang: PropTypes.string,
	remove: PropTypes.func,
	intl: PropTypes.func,
	can: PropTypes.func,
	affiliatesLookup: PropTypes.func,
	landingsFormData: PropTypes.object,
	shouldTranslate: PropTypes.bool
};

export default reduxForm({
	form: 'programsLandingForm'
})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/forms/landings/main.js